import { createContext } from "react";

export interface ExpansionContextValue {
  readonly bare: boolean;
  readonly expanded: boolean;
}

export const ExpansionContext = createContext<ExpansionContextValue>({
  bare: false,
  expanded: false,
});
